import { createActionGroup, props } from "@ngrx/store";
import { PaginationMetadata, QuoteList, QuoteSearchRequest } from "src/api-service";
import { AppError } from "../../../../app-store-error.types";

export const QuoteSearchActions = createActionGroup({
    source: "Super User / Quote Search",
    events: {
        "Search Quotes": props<{ request: Partial<QuoteSearchRequest> }>(),
        "Search Quotes Success": props<{ quotes: QuoteList[]; pagination: PaginationMetadata }>(),
        "Search Quotes Failure": props<{ error: AppError; toastKey: string }>(),
    },
});
